import type { C1_BaseObject } from "../model/C1_BaseObject";

/** Resolves context for a separate panel without changing the action selection. */
export function dockGroupForSelection(selection: C1_BaseObject<any> | undefined): C1_BaseObject<any> | undefined {
  const seen = new Set<C1_BaseObject<any>>();
  for (let candidate = selection; candidate && !seen.has(candidate); candidate = candidate.parent) {
    if (["C1_Room", "C1_Opening", "C1_Furniture"].includes(candidate.className)) return candidate;
    seen.add(candidate);
  }
  return undefined;
}
